import { Component } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';

import { Activity } from '../../models/activity/activity.model';
import { Stylist } from '../../models/stylist/stylist.model';
import { UserService } from '../../services/user.service';
import { StylistService } from '../../services/stylist.service';
import { Utilities } from '../../utilities/utilities';
import { List } from 'immutable';
import {Router, ActivatedRoute, NavigationExtras} from '@angular/router';
import { AlertService } from '../../utilities/alert.service';
@Component({
  selector: 'app-activity-list',
  templateUrl: './activity-list.page.html',
  styleUrls: ['./activity-list.page.scss'],
})
export class ActivityListPage {

  public activities: List<Activity>;

  public isLoading: boolean;

  public stylistID: number;

  public readOnlyStylistPicker: boolean;

  public isModal: boolean;

  constructor (private userService: UserService,
    private stylistService: StylistService,
    //private navCtrl: NavController,
    //private navParams: NavParams,
    private modalController: ModalController,
    private router:Router,
    private alertCtrl: AlertController,
    private alertService: AlertService,
    private route: ActivatedRoute) {
    this.activities = List([]);
    this.isLoading = true
   // this.isModal = (this.navParams.get('modal') !== undefined) ? this.navParams.get('modal') : false;
   this.isModal = route.snapshot.params.isModal ? route.snapshot.params.isModal: false ;
    
    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      if (user.isAdministrator()) {
        this.readOnlyStylistPicker = false;
      } else {
        this.readOnlyStylistPicker = true;
      }
    }
  }


  public onStylistPickerInit(initResponse: {success: boolean, stylist: Stylist}) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      // TODO: tap to reload

    }
  }

  public onStylistSelect (stylist: Stylist) {
    this.stylistID = stylist.getID();
    this.loadActivites(stylist);
  }

  public loadActivites (stylist: Stylist) {
    
    if (isNaN(this.stylistID)) {
      throw new Error('stylistID is not required.');
    }

    this.isLoading = true;
    this.activities = List([]);
    this.stylistService.getActivities(stylist)
      .subscribe({
        next:(activities) =>{
          this.activities = activities;
          this.isLoading = false;
        },
        error: (e) => {
          this.isLoading = false;
          //this.alertCtrl.create(Utilities.getDefaultErrorMessageConfig()).present();
          this.alertService.presentErrorAlert();
        }
      });
  }

  public onDismiss () {
    if (this.isModal) {
      this.modalController.dismiss();
    }
  }

  public onNotificationSettingsTap () {
    this.router.navigateByUrl('NotificationSettingsPage');
  }

  public timeElapsed (activity: Activity) : string {
    const timeStart = activity.getTime().getTime();
    const timeEnd = new Date().getTime(); // Todays time
    const hourDiff = timeEnd - timeStart; //in ms
    let secs = hourDiff/1000;
    let minutes = secs    / 60 ;  
    secs    = secs    % 60;
    let hours   = minutes / 60 ;  
    minutes = minutes % 60;
    const days = hours / 24; hours = hours % 24;

    const humanReadable = {};
    humanReadable['secs'] = Math.floor(secs);
    humanReadable['minutes'] = Math.floor(minutes);
    humanReadable['hours'] = Math.floor(hours);
    humanReadable['days'] = Math.floor(days);

    if(humanReadable['days'] && humanReadable['days'] > 0){
        return humanReadable['days'] + " d";
    }

    if(humanReadable['hours'] && humanReadable['hours'] > 0){
        return humanReadable['hours'] + " h";
    }

    if(humanReadable['minutes'] && humanReadable['minutes'] > 0){
        return humanReadable['minutes'] + " m";
    }

    if(humanReadable['secs'] && humanReadable['secs'] > 0){
        return humanReadable['secs'] + " s";
    }
  }


}
